import { Grid } from "@mui/material";
import Input from "../../../components/input/Input-v2";
import { SubmitHandler, useForm } from "react-hook-form";
import InputCategory from "./__components/InputCategory";
import InputBrand from "./__components/InputBrand";
import { LoadingButton } from "../../../components/button/Button";
import { useGetProduct, useUpdateProduct } from "../api/product/resolver";
import { useEffect } from "react";
import { MainContainerForm } from "../../../styles/Main.styles";
import { useUserInformation } from "../../../context/userInformation/UserInformationContext";

interface FormUpdate {
  productId: string;
}

export type Form_Update_Product = {
  product_id: string;
  product_type_name: string;
  product_category_id: number;
  product_brand_id: number;
  unit_type: string;
  price: number | string;
  wholesale_price: number | string;
  buying_price: number | string;
  stock: number | string;
  has_tax: number | string;
};

export default function FormUpdate({ productId }: FormUpdate) {
  const userInfo = useUserInformation();
  const isAsAdmin = userInfo.validateByRole("Admin");
  const { data: dataRawProduct, isLoading: loadingFetch } = useGetProduct({
    product_id: productId,
  });
  const dataProduct = dataRawProduct?.data.data;
  const { mutate: mutateUpdate, isLoading: loadingUpdate } = useUpdateProduct();
  const { handleSubmit, control, setValue } = useForm<Form_Update_Product>({
    defaultValues: {
      product_id: productId,
      product_type_name: "",
      unit_type: "",
      price: "",
      wholesale_price: "",
      buying_price: "",
      stock: "",
      has_tax: "",
    },
  });

  const handleFormSubmit: SubmitHandler<Form_Update_Product> = (data) => {
    mutateUpdate({ ...data });
  };

  useEffect(() => {
    if (dataProduct) {
      setValue("product_type_name", dataProduct.product_type_name);
      setValue("product_category_id", dataProduct.product_category_id);
      setValue("product_brand_id", dataProduct.product_brand_id);
      setValue("unit_type", dataProduct.unit_type);
      setValue("price", dataProduct.price);
      setValue("wholesale_price", dataProduct.wholesale_price);
      setValue("buying_price", dataProduct.buying_price);
      setValue("stock", dataProduct.stock);
      setValue("has_tax", dataProduct.has_tax);
    }
  }, [dataProduct]);

  return (
    <MainContainerForm>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputCategory
              disabled={isAsAdmin}
              control={control}
              controlName="product_category_id"
            />
          </Grid>
          <Grid item xs={12}>
            <InputBrand
              disabled={isAsAdmin}
              control={control}
              controlName="product_brand_id"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="product_type_name"
              render={(field, fieldState) => (
                <Input.Text
                  disable={isAsAdmin}
                  isFetching={loadingFetch}
                  label="Nama Tipe Produk"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="unit_type"
              render={(field, fieldState) => (
                <Input.Text
                  disable={isAsAdmin}
                  isFetching={loadingFetch}
                  label="Satuan Produk"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="buying_price"
              render={(field, fieldState) => (
                <Input.Money
                  disabled={isAsAdmin}
                  isFetching={loadingFetch}
                  label="Harga Beli"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="wholesale_price"
              render={(field, fieldState) => (
                <Input.Money
                  isFetching={loadingFetch}
                  label="Harga Grosir"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="price"
              render={(field, fieldState) => (
                <Input.Money
                  isFetching={loadingFetch}
                  label="Harga"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="stock"
              render={(field, fieldState) => (
                <Input.Money
                  isFetching={loadingFetch}
                  label="Stock"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="has_tax"
              render={(field, fieldState) => (
                <Input.Select
                  disable={isAsAdmin}
                  isFetching={loadingFetch}
                  label="Pajak"
                  options={[
                    { text: "Ya", value: 1 },
                    { text: "Tidak", value: -1 },
                  ]}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
            <LoadingButton
              isLoading={loadingUpdate}
              type="submit"
              text="Update"
            />
          </Grid>
        </Grid>
      </form>
    </MainContainerForm>
  );
}
